import { getOwaMonarchReferralCampaignStore } from "../store/OwaMonarchReferralCampaignStore";
import type { OwaMonarchReferralViewState } from "../store/schema/owaMonarchReferralCampaignState";

export const getOwaMonarchReferralCampaignViewState = (): OwaMonarchReferralViewState => {
    return getOwaMonarchReferralCampaignStore().viewState;
};

export interface OwaMonarchReferralCampaignDetails {
    title: string;
    body: string;
    primaryCta: string;
    secondaryCta: string;
    image: string;
    campaignId: string;
    trackingBaseUri: string | undefined;
    impressionBaseUri: string | undefined;
}

export const getOwaMonarchReferralCampaignDetails = (): OwaMonarchReferralCampaignDetails => {
    const { title, body, primaryCta, secondaryCta, image, campaignId, trackingBaseUri, impressionBaseUri, } = getOwaMonarchReferralCampaignStore();
    return {
        title,
        body,
        primaryCta,
        secondaryCta,
        image,
        campaignId,
        trackingBaseUri,
        impressionBaseUri,
    };
};
